module.exports = __webpack_public_path__ + "img/icon_chip_08.c0ac50e7.png";